import iconOne from '../../assets/features/1.webp';
import iconTwo from '../../assets/features/2.webp';
import iconThree from '../../assets/features/3.webp';
import iconFour from '../../assets/features/4.webp';

const featuresData = [
    {
        'icon': iconOne,
        'title': 'Safety first',
        'description': 'We prioritize safety with health checks and more'
    },
    {
        'icon': iconTwo,
        'title': 'Insurance accepted',
        'description': 'We’re in network with major insurers like Delta Dental, Aetna, and Cigna.'
    },
    {
        'icon': iconThree,
        'title': 'Full-service dentistry',
        'description': 'Our clinic offer a full  of dental service, from exams to implants and veneers.'
    },
    {
        'icon': iconFour,
        'title': 'No judgment ever',
        'description': 'From floss bosses to sweet tooths, every mouth is welcome.'
    }
]

export default featuresData;